import React from "react";
import { useGetSingleInquiryQuery } from "../../store/api/cartApi";
import styles from "./UserProfile.module.css";
import diamondDummy from "../../assets/diamonds/diamond_round.png";
import { FaChevronRight } from "react-icons/fa6";
import Loader from "../../components/common/Loader";

const InquiryModelDetails = ({ selectedInquiry }) => {
  const {
    data: inquiryDetails,
    isLoading: inquiryDetailsLoading,
    isFetching: inquiryDetailsFetching,
  } = useGetSingleInquiryQuery(selectedInquiry, { skip: !selectedInquiry });
  return (
    <div className="inquiry-detail-container">
      {(inquiryDetailsLoading || inquiryDetailsFetching) && <Loader />}
      <div className={styles?.countLabel}>
        Total items : {inquiryDetails?.inquiry?.item_count}
      </div>
      <ul className={styles.cartList}>
        {inquiryDetails?.inquiry?.items?.map((item, idx) => (
          <li
            key={idx}
            className={styles.listitem}
            // className="align-items-center d-flex justify-content-between mb-3 p-2"
          >
            <div className="d-flex gap-3">
              <img
                src={diamondDummy}
                alt={item.title}
                className={styles.cartImage}
              />
              <div>
                <div className={styles.cartTitle}>
                  {item?.shape} {item?.color} {item?.carat} {item?.clarity}
                </div>
                <div className={styles.cartDesc}>Lab : {item?.lab}</div>
                <div className={styles.viewDetails}>
                  {" "}
                  View Details <FaChevronRight />
                </div>
              </div>
            </div>
            <div className={styles.prices}>
              Total price : ${Number(item?.total_price).toFixed(2)} <br />
              Price per carat : ${Number(item?.price_per_carat).toFixed(2)}
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default InquiryModelDetails;
